import Vuex from 'vuex'
import Vue from 'vue'
import mspStore from './msp-store'
import authStore from './auth-store'
import applicationStore from './application-store'
import tenantStore from './tenant-store'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules: {
    msp: {
      namespaced: true,
      ...mspStore
    },
    auth: {
      namespaced: true,
      ...authStore
    },
    application: {
      namespaced: true,
      ...applicationStore
    },
    tenant: {
      namespaced: true,
      ...tenantStore
    }
  }
})
